@if (visible()) {
  <div class="competitor-overview" [class.desktop]="isDesktop()">
    <app-v3-overview-card-header
      icon="/v3/competitors.svg"
      title="Wettbewerb"
      [updatedAt]="updatedAt()"
      actionLabel="Alle Wettbewerber"
      (navigate)="onNavigate()"
    ></app-v3-overview-card-header>

    <app-v3-competitor-highlights
      [desktop]="isDesktop()"
      [advantage]="advantage()"
      [risk]="risk()"
    ></app-v3-competitor-highlights>

    <div class="section-divider"></div>
    <app-v3-competitor-table
      [peers]="peers()"
      [limit]="4"
      [desktop]="isDesktop()"
      [finnetMobile]="isFinnet() && !isDesktop()"
      [livePrices]="livePrices"
      (navigateToInstrument)="navigateToInstrument.emit($event)"
    ></app-v3-competitor-table>

    @if (isFinnet() && !isDesktop()) {
      <button class="competitor-details" type="button" (click)="onNavigate()">
        <span>Alle Wettbewerber</span>
        <span class="caret"></span>
      </button>
    }
  </div>
}
